import React from 'react';
import { Card, NavItem, TabContent, TabPane, NavLink, Container, Nav, CardHeader, Row, Col } from "reactstrap";
import Layout from "../HorizontalMenu/Menu";
import Navbar from "../HorizontalMenu/Navbar";
import classnames from "classnames";
import { useDispatch } from 'react-redux';
import { VesselState, setVesselMasterPageURL, setVesselState } from "../Store/Generic/ReportingSlice";
import VesselDetailsHeader from 'Components/VesselDetailsHeader';
import OngoingVoyage from './OngoingVoyage';
import PreviousVoyages from './PreviousVoyages';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { queryKeyes } from 'shared/queryKeys';
import { hasRole } from 'utils/auth/authUtils';
import { Roles } from 'shared/constants';

const VoyageInformation = ({
    activeVoyageTab,
    setActiveVoyageTab,
}: any) => {
    const dispatch = useDispatch();
    useDocumentTitle(activeVoyageTab === '1' ? 'Ongoing Voyage - ecoSAIL' : 'Previous Voyages - ecoSAIL');

    const toggle = (tab: any) => {
        if (activeVoyageTab !== tab) {
            setActiveVoyageTab(tab);
        }
    }

    const handleVesselState = (record: VesselState) => {
        dispatch(setVesselState(record))
    }
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardHeader className='pb-0'>
                            <Row>
                                <Col sm={2}>
                                    <button
                                        color='primary'
                                        className='btn btn-primary mb-3'
                                        onClick={() => {
                                            if (hasRole(Roles.MASTER) || hasRole(Roles.CHIEFENGINEER)) {
                                                window.location.href = "/dashboard";
                                            } else {
                                                handleVesselState(null);
                                                dispatch(setVesselMasterPageURL(queryKeyes.pagination.vesselListPage.url('true')));
                                            }
                                        }}
                                    >
                                        <i className="bx bx-chevron-left me-1" />
                                        Back
                                    </button>
                                </Col>
                                <Col sm={10}>
                                    <VesselDetailsHeader />
                                </Col>
                            </Row>
                            <Nav tabs className='border-0'>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeVoyageTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                        }}
                                    >
                                        Ongoing Voyage
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeVoyageTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                        }}
                                    >
                                        Previous Voyages
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </CardHeader>
                        <TabContent activeTab={activeVoyageTab} className="text-muted">
                            <TabPane tabId="1" className='margin-16'>
                                <OngoingVoyage />
                            </TabPane>
                            <TabPane tabId="2" className='margin-16'>
                                <PreviousVoyages
                                    setActiveVoyageTab={setActiveVoyageTab}
                                />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Container>
            </div >
        </React.Fragment >
    )
}

export default VoyageInformation